import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type {
  CommunityEventContentObjectDataObject,
  EventContentObjectDataObject,
  ProgramEventDataObject,
  PublicEventContentObjectDataObject,
} from 'models/service';

type EventParams = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  invitation_token?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const getEvent = async <
  T extends
    | CommunityEventContentObjectDataObject
    | EventContentObjectDataObject
    | ProgramEventDataObject
    | PublicEventContentObjectDataObject,
>(
  id: string,
  params?: EventParams,
) =>
  apiClient.get<T, ApiClientResponse<T>>(routes.events.get(id), {
    params,
  });
